import React, { useState, useEffect, useRef } from "react";
import EntityHeader from "./common/EntityHeader";
import Card from "react-bootstrap/Card";
import FieldDisplay from "./common/FieldDisplay";
import ParentPartnerCountyModal from "./ParentPartnerCountyModal";
import {
  formatDate,
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../scripts/helperScripts";

import { getClientProgramIdentifiers } from "./services/soar";

function ParentPartnerCountyEntity({
  clientId,
  clientProgram,
  showExpired,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [countyIdentifiers, setCountyIdentifiers] = useState([]);
  const [data, setData] = useState({});
  const [updateCountyIdentifiers, setUpdateCountyIdentifiers] = useState(false);
  const isMountedRef = useRef(true);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    if (clientProgram && clientProgram.ccx_client_programid) {
      console.log("Getting Counties for ", clientProgram.ccx_client_programid);
      getClientProgramIdentifiers(
        clientProgram.ccx_client_programid,
        safyInfo.user.safyInfo.BusinessUnitIdName
      ).then((response) => {
        if (response && isMountedRef.current) {
          console.log("Counties:", response);
          const counties = response.filter(
            (cpid) =>
              cpid.ccx_clientprogramidentifiertype["#text"] === "186460003"
          );
          setCountyIdentifiers(counties);
          setUpdateCountyIdentifiers(false);
        } else {
          console.log("No counties returned");
        }
      });
    } else {
      setCountyIdentifiers([]);
      setUpdateCountyIdentifiers(false);
    }
  }, [clientProgram, updateCountyIdentifiers === true]);

  const showModal = (identifier) => {
    const obj = {
      ccx_clientprogramidentifierid: identifier.ccx_clientprogramidentifierid,
      ccx_name: identifier.ccx_name,
      ccx_clientprogramidentifiertype: "186460000",
      ccx_effdate: formatDate(getFieldText(identifier.ccx_effdate)),
      ccx_expdate: identifier.ccx_expdate
        ? formatDate(getFieldText(identifier.ccx_expdate))
        : "",
    };
    setData(obj);
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const addNew = () => {
    setData({});
    setIsOpen(true);
  };

  const handleUpdateIdentifiers = () => {
    setUpdateCountyIdentifiers(true);
  };

  return (
    <>
      {isOpen ? (
        <ParentPartnerCountyModal
          isOpen={isOpen}
          hideModal={() => hideModal()}
          initialData={data}
          clientProgram={clientProgram}
          updateIdentifiers={handleUpdateIdentifiers}
        ></ParentPartnerCountyModal>
      ) : null}
      <EntityHeader
        {...rest}
        title="Parent Partner County"
        add={addNew}
        clientId={clientId}
        body={countyIdentifiers.map((identifier) => (
          <div
            className={
              identifier.ccx_expdate === undefined ||
              new Date(getFieldText(identifier.ccx_expdate)) > new Date() ||
              showExpired
                ? "d-block p-2"
                : "d-none p-2"
            }
            key={identifier.ccx_clientidentifiersid}
          >
            <Card className="card-safy">
              <Card.Header
                className="p-0 ps-2 bg-safy1-1"
                style={{ color: "white" }}
              >
                <div className="row">
                  <div className="col-10 ps-4 pt-1">{identifier.ccx_name}</div>
                  <div className="col-2">
                    <i
                      className="fas fa-pen float-end p-2"
                      onClick={() => showModal(identifier)}
                    ></i>
                  </div>
                </div>
              </Card.Header>
              <Card.Body
                className={
                  identifier.ccx_expdate === undefined ||
                  new Date(getFieldDate(identifier.ccx_expdate)) > new Date()
                    ? "p-2 card-body-safy"
                    : "p-2 bg-warning"
                }
              >
                {identifier.ccx_effdate && (
                  <FieldDisplay
                    label="Effective Date"
                    value={getFieldDate(identifier.ccx_effdate)}
                  />
                )}
                {identifier.ccx_expdate && (
                  <FieldDisplay
                    label="Expiration Date"
                    value={getFieldDate(identifier.ccx_expdate)}
                  />
                )}
              </Card.Body>
            </Card>
          </div>
        ))}
      />
    </>
  );
}

export default ParentPartnerCountyEntity;
